import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/cultura';

export default {
    buscarPorCodigo(codigos) {
        return http.get({
            url: baseUrl + `/codigo?codigos=${codigos}`,
            lockScreen: true,
            lockMessage: 'Aguarde, buscando dados de culturas.'
        });
    },
    findCultura() {
        return http.get({
            url: baseUrl + `/territorio-sise`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoProdutos')
        });
    }
};
